import styled, { css } from 'styled-components'
import { SecondaryTitle } from '../Post/Post.styles'
import { device } from '../../styles/GlobalVariables'
import AdPlacementCss from '../Ads/AdPlacementCss'

export const PostsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 19px;

  ${SecondaryTitle} {
    display: none;
  }

  ${device.medium} {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr 1fr;
    gap: 30px 20px;
  }

  ${device.large} {
    gap: 30px 30px;
  }
`

export const Container = styled.div`
  display: flex;
  flex-direction: column;
`

export const Banner = styled.div`
  display: flex;
  justify-content: center;
  flex-grow: 0;
  //margin: 0 auto;
  ${props =>
    props.theme.collapse === 'true'
      ? css`
          display: none;
        `
      : ''};

  ${device.medium} {
    //margin: unset;
    display: ${props =>
      props.theme.collapse === 'true' ? 'none' : 'inline-block'};
  }

  &.Box_7 {
    display: none;

    ${device.small} {
      display: ${props =>
        props.theme.collapse === 'true' ? 'none' : 'inline-block'};
    }
  }

  > div {
    width: 100%;

    > div {
      text-align: center;
    }
  }

  iframe {
    min-height: 90px;
  }

  margin-left: auto;
  margin-right: auto;
  ${props =>
    props.theme.collapse === 'true'
      ? AdPlacementCss({ width: 300, height: 250 })
      : ''};
`

export const CustomIframe = styled.iframe`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 190px;

  border: unset;

  ${device.large} {
    height: 170px;
  }
`
